import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import { SwipeableDrawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
// for custom progressbar design
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));
const StyledTableRow = styled(Index.TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#efefef",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const AddScheduleTable = () => {
  const navigate = PagesIndex.useNavigate();
  const formRef = useRef();
  const params = PagesIndex.useParams();
  const { id, page } = params;
  const location = PagesIndex.useLocation();
  const { state } = location;
  const [days, setDays] = useState([]);
  const [advertiserList, setAdvertiserList] = useState([]);
  const [creativeList, setCreativeList] = useState([]);
  const [scheduleData, setScheduleData] = useState([]);
  const [selectedSlotData, setSelectedSlotData] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [selectDeleted, setSelectDeleted] = useState([]);
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [durationError, setDurationError] = useState("");
  const [openCalenderStart, setOpenCalenderStart] = useState(false);
  const [openChangeSlot, setOpenChangeSlot] = useState(false);
  const [openChangeSlotTiming, setOpenChangeSlotTiming] = useState(false);
  const [creativeId, setCreativeId] = useState("");
  const [slotId, setSlotId] = useState("");
  const [movableSlotTime, setMovableSlotTime] = useState("");
  const [openStartTime, setOpenStartTime] = useState(false);
  const [openEndTime, setOpenEndTime] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(
    PagesIndex.dayjs().format("YYYY-MM-DD") >
      PagesIndex.moment(state?.endDate).format("YYYY-MM-DD")
      ? PagesIndex.dayjs(state?.endDate)
      : PagesIndex.dayjs().format("YYYY-MM-DD") <
        PagesIndex.moment(state?.startDate).format("YYYY-MM-DD")
      ? PagesIndex.dayjs(state?.startDate)
      : PagesIndex.dayjs()
  );
  const initialValues = {
    advertiser: "",
    creative: {},
    priority: "default",
    noOfTimesPlay: "",
  };
  const initialValuesChangeSlot = {
    slotId: slotId,
    creativeId: creativeId,
  };
  const initialValuesChangeSlotTimings = {
    slotId: selectedSlotData?._id,
    startTime: selectedSlotData?.startTime
      ? PagesIndex.dayjs(selectedSlotData?.startTime)
      : null,
    endTime: selectedSlotData?.endTime
      ? PagesIndex.dayjs(selectedSlotData?.endTime)
      : null,
  };
  const fetchData = useCallback((api, setState, filterFn) => {
    PagesIndex.apiGetHandler(api).then((res) => {
      if (res?.status === 200) {
        setState(filterFn ? filterFn(res?.data) : res?.data);
      }
    });
  }, []);
  const handleGetAdvertiser = useCallback(() => {
    fetchData(PagesIndex.Api.GET_ALL_ADVERTISER, setAdvertiserList, (data) =>
      data.filter((item) => item?.isActive && !item?.isDraft)
    );
  }, [fetchData]);
  const handleGetCreatives = useCallback(() => {
    fetchData(PagesIndex.Api.GET_CREATIVES, setCreativeList, (data) =>
      data.filter((item) => item?.isActive)
    );
  }, [fetchData]);
  const handleGetScheduleData = useCallback(() => {
    const urlEncoded = new URLSearchParams();
    urlEncoded.append(
      "startDate",
      PagesIndex.dayjs(new Date(startDate)).format("YYYY-MM-DD")
    );
    PagesIndex.apiPostHandler(
      PagesIndex.Api.GET_SLOT_SCHEDULE + "/" + id,
      urlEncoded
    ).then((res) => {
      if (res?.status === 200) {
        setScheduleData(res?.data);
      } else {
        setScheduleData([]);
      }
    });
  }, [startDate, id]);
  const getWeekDays = useCallback(() => {
    let days = [];
    const start = PagesIndex.moment(new Date(startDate)).format("YYYY-MM-DD");
    const end = PagesIndex.moment(new Date(startDate)).format("YYYY-MM-DD");
    const startDateVal = PagesIndex.moment(new Date(start));
    const endDateVal = PagesIndex.moment(new Date(end));
    let daysRequired = endDateVal.diff(startDateVal, "days");
    for (let i = 0; i <= daysRequired; i++) {
      let objData = {
        date: PagesIndex.moment(startDateVal)
          .add(i, "day")
          .format("DD-MM-YYYY"),
      };
      days.push(objData);
    }
    setDays(days);
  }, [startDate]);
  useEffect(() => {
    handleGetAdvertiser();
    handleGetCreatives();
    handleGetScheduleData();
  }, [handleGetAdvertiser, handleGetCreatives, handleGetScheduleData]);
  useEffect(() => {
    handleGetScheduleData();
    getWeekDays();
  }, [startDate, handleGetScheduleData, getWeekDays]);
  // filter
  const [stateFilter, setStateFilter] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer = useCallback((anchor, open) => {
    if (!open) {
      setDurationError("");
      formRef.current.resetForm();
    }
    setStateFilter((prevState) => ({ ...prevState, [anchor]: open }));
  }, []);
  const normalise = useCallback((value, diff) => {
    return ((value - 0) * 100) / (diff - 0);
  }, []);
  const handleClickCell = useCallback(
    (data) => {
      toggleDrawer("right", true);
      setSelectedSlotData(data?.tempData);
      setSelectedData(data?.schedules);
    },
    [toggleDrawer]
  );
  const handleAddEditSchedule = useCallback(() => {
    setButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    urlEncoded.append("id", id);
    urlEncoded.append("slotDataId", selectedSlotData?._id);
    urlEncoded.append("ads", JSON.stringify(selectedData));
    urlEncoded.append("deleteIds", JSON.stringify(selectDeleted));
    PagesIndex.apiPostHandler(
      PagesIndex.Api.ADD_EDIT_SLOT_SCHEDULE,
      urlEncoded
    ).then((res) => {
      setButtonSpinner(false);
      if (res?.status === 200) {
        handleGetScheduleData();
        setSelectDeleted([]);
        toggleDrawer("right", false);
      }
    });
  }, [
    id,
    selectedSlotData,
    selectedData,
    selectDeleted,
    handleGetScheduleData,
    toggleDrawer,
  ]);
  const handleRemoveSelectedData = useCallback((indexOuter, data) => {
    setSelectedSlotData((prev) => ({
      ...prev,
      leftDuration: prev?.leftDuration + data?.creative?.duration,
    }));
    setSelectedData((prev) =>
      prev.filter((_, indexInner) => indexInner !== indexOuter)
    );
    if (data?._id) {
      setSelectDeleted((prev) => [...prev, data?._id]);
    }
  }, []);
  const handleAddData = useCallback((values) => {
    setSelectedSlotData((prev) => {
      if (prev?.leftDuration - values?.creative?.duration < 0) {
        PagesIndex.toasterError(
          "Selected creative exceeds break duration, Select different creative"
        );
        return prev;
      } else {
        setSelectedData((prev) => [...prev, values]);
        return {
          ...prev,
          leftDuration: prev?.leftDuration - values?.creative?.duration,
        };
      }
    });
  }, []);
  const handleOpenChangeSlot = useCallback((id, creativeId, slotData) => {
    setSlotId(id);
    setSelectedSlotData(slotData);
    setCreativeId(creativeId);
    setOpenChangeSlot(true);
  }, []);
  const handleCloseChangeSlot = useCallback(() => {
    setSlotId("");
    setCreativeId("");
    setOpenChangeSlot(false);
  }, []);
  const handleOpenChangeSlotTiming = useCallback((slotData) => {
    setSelectedSlotData(slotData);
    setOpenChangeSlotTiming(true);
  }, []);
  const handleCloseChangeSlotTiming = useCallback(() => {
    setSelectedSlotData("");
    setOpenStartTime(false);
    setOpenEndTime(false);
    setOpenChangeSlotTiming(false);
  }, []);
  const handleChangeSlot = useCallback(
    (values) => {
      setButtonSpinner(true);
      const urlEncoded = new URLSearchParams();
      urlEncoded.append("slotId", values?.slotId);
      urlEncoded.append("scheduleId", values?.creativeId);
      PagesIndex.apiPostHandler(
        PagesIndex.Api.CHANGE_SLOT_LOCATION,
        urlEncoded
      ).then((res) => {
        setButtonSpinner(false);
        if (res?.status === 200) {
          handleGetScheduleData();
          handleCloseChangeSlot();
        }
      });
    },
    [handleGetScheduleData, handleCloseChangeSlot]
  );
  const handleChangeSlotTimings = useCallback(
    (values) => {
      setButtonSpinner(true);
      const urlEncoded = new URLSearchParams();
      urlEncoded.append("slotId", values?.slotId);
      urlEncoded.append(
        "startTime",
        PagesIndex.dayjs(values?.startTime).format("HH:mm")
      );
      urlEncoded.append(
        "endTime",
        PagesIndex.dayjs(values?.endTime).format("HH:mm")
      );
      PagesIndex.apiPostHandler(
        PagesIndex.Api.CHANGE_SLOT_TIMING,
        urlEncoded
      ).then((res) => {
        setButtonSpinner(false);
        if (res?.status === 200) {
          handleGetScheduleData();
          handleCloseChangeSlotTiming();
        }
      });
    },
    [handleGetScheduleData, handleCloseChangeSlotTiming]
  );

  const handleDateChange = useCallback((date) => {
    setStartDate(PagesIndex.dayjs(new Date(date)));
  }, []);

  const handleDatePickerOpen = () => {
    setOpenCalenderStart(true);
  };

  const handleDatePickerClose = useCallback(() => {
    setOpenCalenderStart(false);
  }, []);

  return (
    <Index.Box className="admin-dashboard-content admin-user-list-content">
      <Index.Box className="admin-user-list-flex admin-page-title-main">
        <Index.Typography
          className="admin-page-title admin-user-list-page-title"
          component="h2"
          variant="h2"
        >
          {page === "FCT" ? "FCT" : "Non FCT"} Schedule
        </Index.Typography>
        <Index.Box className="admin-userlist-inner-btn-flex">
          <Index.Box className="admin-modal-input-box admin-date-input-main">
            <Index.Box className="admin-form-group" id="startDate">
              <PagesIndex.LocalizationProvider dateAdapter={Index.AdapterDayjs}>
                <PagesIndex.DatePicker
                  open={openCalenderStart}
                  onClose={handleDatePickerClose}
                  className="admin-form-control admin-date-picker-control"
                  value={startDate}
                  minDate={PagesIndex.dayjs(state?.startDate).add(0, "day")}
                  maxDate={PagesIndex.dayjs(state?.endDate).add(0, "day")}
                  onChange={handleDateChange}
                  slotProps={{
                    popper: {
                      className: "date-picker-body",
                    },
                    textField: {
                      readOnly: true,
                      onClick: handleDatePickerOpen,
                    },
                    inputAdornment: {
                      onClick: handleDatePickerOpen, // This triggers on the calendar icon
                    },
                  }}
                  format="DD/MM/YYYY"
                />
              </PagesIndex.LocalizationProvider>
            </Index.Box>
          </Index.Box>
          <Index.Box className="admin-adduser-btn-main btn-main-primary">
            <Index.Button
              className="admin-adduser-btn btn-primary"
              onClick={() => {
                navigate(`/admin/view-slot-schedule/${page}/${id}`, {
                  state: state,
                });
              }}
            >
              <span>View Schedule</span>
            </Index.Button>
          </Index.Box>
        </Index.Box>
      </Index.Box>
      <Index.Box className="common-card">
        <Index.Box className="page-table-main add-schedule-table-main">
          <Index.TableContainer
            component={Index.Paper}
            className="table-container"
          >
            <Index.Table aria-label="simple table" className="table">
              <Index.TableHead className="table-head">
                <Index.TableRow className="table-row">
                  <Index.TableCell
                    component="th"
                    variant="th"
                    className="table-th"
                    // width="10%"
                  >
                    Slot
                  </Index.TableCell>
                  {days?.map((data) => {
                    return (
                      <Index.TableCell
                        component="th"
                        variant="th"
                        className="table-th"
                        key={data?.date}
                      >
                        {data?.date}
                      </Index.TableCell>
                    );
                  })}
                </Index.TableRow>
              </Index.TableHead>
              <Index.TableBody className="table-body">
                {scheduleData?.length ? (
                  scheduleData
                    // ?.slice((currentPage - 1) * 12, (currentPage - 1) * 12 + 12)
                    ?.map((data, index) => {
                      const priorityCounts = data?.schedules.reduce(
                        (acc, item) => {
                          if (
                            ["first", "second", "last"].includes(item.priority)
                          ) {
                            acc[item.priority] = (acc[item.priority] || 0) + 1;
                          }
                          return acc;
                        },
                        {}
                      );
                      const repeatedPriorities = Object.keys(
                        priorityCounts
                      ).filter((priority) => priorityCounts[priority] > 1);
                      return (
                        <StyledTableRow
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <Index.TableCell
                            component="td"
                            variant="td"
                            scope="row"
                            className="table-td"
                          >
                            <Index.Typography
                              className="admin-table-slot-box"
                              onClick={() => {
                                if (data?.tempData?._id && page === "FCT") {
                                  handleOpenChangeSlotTiming(data?.tempData);
                                }
                              }}
                            >
                              {PagesIndex.moment(
                                data?.tempData?.startTime
                              ).format("HH:mm")}{" "}
                              -{" "}
                              {PagesIndex.moment(
                                data?.tempData?.endTime
                              ).format("HH:mm")}
                            </Index.Typography>
                          </Index.TableCell>
                          {days?.map((dataDays) => {
                            return (
                              <Index.TableCell
                                component="td"
                                variant="td"
                                scope="row"
                                className="table-td"
                                key={dataDays?.date}
                              >
                                <Index.Box className="slot-content-main">
                                  <Index.Box className="slot-flex">
                                    {data?.schedules.map((dataSch) => {
                                      return (
                                        <Index.Box
                                          className="slot-creative-select-text"
                                          key={dataSch?._id}
                                          onClick={(e) => {
                                            handleOpenChangeSlot(
                                              data?.tempData?._id,
                                              dataSch?._id,
                                              data?.tempData
                                            );
                                            setMovableSlotTime({
                                              movebleStartTime:
                                                dataSch?.movebleStartTime,
                                              movebleEndTime:
                                                dataSch?.movebleEndTime,
                                            });
                                          }}
                                          style={{
                                            backgroundColor:
                                              repeatedPriorities?.includes(
                                                dataSch?.priority
                                              )
                                                ? "#ff0000a3"
                                                : "transparent",
                                            color: repeatedPriorities?.includes(
                                              dataSch?.priority
                                            )
                                              ? "#fff"
                                              : "#6b7280",
                                          }}
                                        >
                                          {dataSch?.priority?.[0]?.toUpperCase() +
                                            dataSch?.priority?.slice(
                                              1,
                                              dataSch?.priority?.length
                                            )}{" "}
                                          | {dataSch?.creative?.code} |{" "}
                                          {dataSch?.creative?.clientId?.advNo} |{" "}
                                          {
                                            dataSch?.creative?.clientId
                                              ?.compName
                                          }{" "}
                                          | {dataSch?.creative?.name} |{" "}
                                          {dataSch?.creative?.elementId?.name}{" "}
                                          {dataSch?.creative?.duration
                                            ? " | " +
                                              dataSch?.creative?.duration
                                            : ""}
                                        </Index.Box>
                                      );
                                    })}
                                  </Index.Box>
                                  <Index.Box className="slot-creative-icon-flex">
                                    {page === "FCT" && (
                                      <Index.Button className="slot-creative-progress-btn">
                                        <span className="slot-value-lable">
                                          {data?.schedules?.reduce(
                                            (acc, crr) =>
                                              acc + crr?.creative?.duration,
                                            0
                                          ) || 0}
                                        </span>
                                        <span className="slot-value-total">
                                          / {data?.tempData?.duration || 0}
                                        </span>
                                      </Index.Button>
                                    )}
                                    <Index.Button
                                      className="slot-creative-icon-btn"
                                      onClick={(e) => {
                                        handleClickCell(data);
                                      }}
                                    >
                                      <img
                                        src={PagesIndex.Svg.plusWhiteIcon}
                                        alt="plus"
                                        className="slot-plus-icon"
                                      />
                                    </Index.Button>
                                  </Index.Box>
                                </Index.Box>
                              </Index.TableCell>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })
                ) : (
                  <PagesIndex.DataNotFound />
                )}
              </Index.TableBody>
            </Index.Table>
          </Index.TableContainer>
          {/* <Index.Box className="admin-pagination-main">
            <Index.Pagination
              page={currentPage}
              count={Math.ceil(state?.slotId?.slot?.length / 12)}
              onChange={(event, newPage) => setCurrentPage(newPage)}
              variant="outlined"
              shape="rounded"
              className="admin-pagination"
            />
          </Index.Box> */}
        </Index.Box>
      </Index.Box>
      <Index.Box className="admin-filter-main">
        {["right"].map((anchor) => (
          <React.Fragment key={anchor}>
            <SwipeableDrawer
              className="drawer-filter-main"
              anchor={anchor}
              open={stateFilter[anchor]}
              onClose={(e) => toggleDrawer(anchor, false)}
            >
              <Index.Box className="admin-filter-header">
                <Index.Typography className="admin-filter-title">
                  Select Creative
                </Index.Typography>
                <Index.Button onClick={(e) => toggleDrawer(anchor, false)}>
                  <img
                    src={PagesIndex.Png.close}
                    className="admin-filter-close-icon"
                    alt="Close"
                  />
                </Index.Button>
              </Index.Box>
              <PagesIndex.Formik
                enableReinitialize
                onSubmit={handleAddData}
                initialValues={initialValues}
                validationSchema={PagesIndex.addSlotSchema}
                innerRef={formRef}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  setFieldTouched,
                }) => {
                  return (
                    <form onSubmit={handleSubmit} noValidate="novalidate">
                      <Index.Box className="admin-filter-inner-main">
                        <Index.Box className="admin-input-box add-user-input">
                          <Index.FormHelperText className="admin-form-lable">
                            Select Client<span className="astrick-sing">*</span>
                          </Index.FormHelperText>
                          <Index.Box className="admin-form-group">
                            <Index.Box className="admin-dropdown-box">
                              <Index.FormControl className="admin-form-control">
                                <Index.Autocomplete
                                  className="admin-auto-complete-control"
                                  options={advertiserList || []}
                                  id="advertiser"
                                  value={
                                    values?.advertiser
                                      ? advertiserList?.find(
                                          (o) => o._id === values.advertiser
                                        ) ?? null
                                      : null
                                  }
                                  disableClearable
                                  closeText={""}
                                  openText={""}
                                  clearText={""}
                                  onChange={(e, value) => {
                                    setFieldValue("advertiser", value?._id);
                                    setFieldTouched("advertiser", false);
                                    setFieldValue("creative", {});
                                    setFieldValue("priority", "default");
                                    setDurationError("");
                                  }}
                                  getOptionLabel={(option) => option?.compName}
                                  renderOption={(props, item) => (
                                    <li {...props} key={item?._id}>
                                      {item?.compName}
                                    </li>
                                  )}
                                  renderInput={(params) => (
                                    <Index.TextField
                                      fullWidth
                                      className="admin-form-control"
                                      {...params}
                                      size="small"
                                      name="advertiser"
                                      placeholder="Select Client"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              </Index.FormControl>
                            </Index.Box>
                          </Index.Box>
                          <PagesIndex.FormHelperText className="admin-error-text">
                            {errors.advertiser && touched.advertiser
                              ? errors.advertiser
                              : null}
                          </PagesIndex.FormHelperText>
                        </Index.Box>

                        <Index.Box className="admin-input-box add-user-input">
                          <Index.FormHelperText className="admin-form-lable">
                            Select Creative
                            <span className="astrick-sing">*</span>
                          </Index.FormHelperText>
                          <Index.Box className="admin-form-group">
                            <Index.Box className="admin-dropdown-box">
                              <Index.FormControl className="admin-form-control">
                                <Index.Autocomplete
                                  className="admin-auto-complete-control"
                                  options={creativeList
                                    .filter(
                                      (data) =>
                                        values?.advertiser ===
                                        data?.clientId?._id
                                    )
                                    .filter((data) => {
                                      if (page === "FCT") {
                                        return (
                                          data?.platformId?._id ===
                                          "664360b5b539341a1a081253"
                                        );
                                      } else if (page === "NonFCT") {
                                        return (
                                          data?.platformId?._id ===
                                          "665465fac233edbd7824176a"
                                        );
                                      }
                                    })}
                                  id="creative"
                                  value={
                                    values?.creative
                                      ? creativeList?.find(
                                          (o) => o._id === values.creative?._id
                                        ) ?? null
                                      : null
                                  }
                                  disableClearable
                                  closeText={""}
                                  openText={""}
                                  clearText={""}
                                  onChange={(e, value) => {
                                    setFieldValue("creative", value);
                                  }}
                                  getOptionLabel={(option) => {
                                    if (page === "FCT") {
                                      return `${option?.code}-${option?.name} (${option?.duration} sec)`;
                                    }
                                    if (page === "NonFCT") {
                                      return `${option?.code}-${option?.name}`;
                                    }
                                  }}
                                  renderOption={(props, item) => (
                                    <li {...props} key={item?._id}>
                                      {item?.code}-{item?.name}{" "}
                                      {page === "FCT"
                                        ? `${item?.duration} sec`
                                        : ""}
                                    </li>
                                  )}
                                  renderInput={(params) => (
                                    <Index.TextField
                                      fullWidth
                                      className="admin-form-control"
                                      {...params}
                                      size="small"
                                      name="creative"
                                      placeholder="Select Creative"
                                      variant="outlined"
                                    />
                                  )}
                                />
                              </Index.FormControl>
                            </Index.Box>
                          </Index.Box>
                          <PagesIndex.FormHelperText className="admin-error-text">
                            {errors.creative?._id ?? durationError ?? null}
                          </PagesIndex.FormHelperText>
                        </Index.Box>
                        {page === "FCT" && (
                          <Index.Box className="admin-input-box add-user-input">
                            <Index.FormHelperText className="admin-form-lable">
                              Priority
                              <span className="astrick-sing">*</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <Index.Box className="admin-dropdown-box">
                                <Index.FormControl className="admin-form-control">
                                  <Index.Select
                                    id="priority"
                                    name="priority"
                                    className="admin-dropdown-select"
                                    value={values?.priority}
                                    onChange={handleChange}
                                    displayEmpty
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                    renderValue={
                                      values?.priority
                                        ? undefined
                                        : () => "Select Priority"
                                    }
                                  >
                                    <Index.MenuItem
                                      value={"default"}
                                      className="admin-menuitem"
                                    >
                                      Default
                                    </Index.MenuItem>
                                    <Index.MenuItem
                                      value={"first"}
                                      className="admin-menuitem"
                                    >
                                      First
                                    </Index.MenuItem>
                                    <Index.MenuItem
                                      value={"second"}
                                      className="admin-menuitem"
                                    >
                                      Second
                                    </Index.MenuItem>
                                    <Index.MenuItem
                                      value={"last"}
                                      className="admin-menuitem"
                                    >
                                      Last
                                    </Index.MenuItem>
                                  </Index.Select>
                                </Index.FormControl>
                              </Index.Box>
                            </Index.Box>
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.priority && touched.priority
                                ? errors.priority
                                : null}
                            </PagesIndex.FormHelperText>
                          </Index.Box>
                        )}
                        {page === "NonFCT" && (
                          <Index.Box className="admin-input-box add-user-input">
                            <Index.FormHelperText className="admin-form-lable">
                              No. Of Times Play
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <Index.TextField
                                fullWidth
                                name="noOfTimesPlay"
                                id="fullWidth"
                                className="admin-form-control"
                                placeholder="Enter No. Of Times Play"
                                value={values?.noOfTimesPlay}
                                onChange={(e) => {
                                  const regex = /^[0-9]*$/;
                                  if (regex.test(e.target.value)) {
                                    handleChange(e);
                                  }
                                }}
                              />
                            </Index.Box>
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.noOfTimesPlay && touched.noOfTimesPlay
                                ? errors.noOfTimesPlay
                                : null}
                            </PagesIndex.FormHelperText>
                          </Index.Box>
                        )}
                        <Index.Box className="admin-filter-btn-main border-btn-main btn-main-primary">
                          <Index.Button
                            className="btn-primary admin-filter-btn"
                            type="submit"
                          >
                            Add
                          </Index.Button>
                        </Index.Box>
                        {page === "FCT" && (
                          <Index.Box className="admin-progress-bar-content">
                            <Index.Box className="admin-progress-bar-main">
                              <BorderLinearProgress
                                variant="determinate"
                                value={normalise(
                                  selectedSlotData?.duration -
                                    selectedSlotData?.leftDuration,
                                  selectedSlotData?.duration
                                )}
                                className="admin-progress-bar"
                              />
                              <span className="admin-progress-bar-text">
                                {selectedSlotData?.duration -
                                  selectedSlotData?.leftDuration}{" "}
                                of {selectedSlotData?.duration} Seconds
                              </span>
                            </Index.Box>
                          </Index.Box>
                        )}
                        {selectedData?.length ? (
                          <>
                            <Index.Box className="analytic-title-flex list-ads-title">
                              <Index.Box className="admin-sub-title-main">
                                <Index.Typography
                                  className="admin-sub-title"
                                  component="h2"
                                  variant="h2"
                                >
                                  List of Ads
                                </Index.Typography>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box className="common-card">
                              <Index.Box className="page-table-main add-schedule-table">
                                <Index.TableContainer
                                  component={Index.Paper}
                                  className="table-container"
                                >
                                  <Index.Table
                                    aria-label="simple table"
                                    className="table"
                                  >
                                    <Index.TableHead className="table-head">
                                      <Index.TableRow className="table-row">
                                        <Index.TableCell
                                          component="th"
                                          variant="th"
                                          className="table-th"
                                        >
                                          Priority
                                        </Index.TableCell>
                                        <Index.TableCell
                                          component="th"
                                          variant="th"
                                          className="table-th"
                                        >
                                          Client Name
                                        </Index.TableCell>
                                        <Index.TableCell
                                          component="th"
                                          variant="th"
                                          className="table-th"
                                        >
                                          Creative
                                        </Index.TableCell>
                                        {page == "FCT" && (
                                          <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                          >
                                            Duration
                                          </Index.TableCell>
                                        )}
                                        {page === "NonFCT" && (
                                          <Index.TableCell
                                            component="th"
                                            variant="th"
                                            className="table-th"
                                          >
                                            No. of Times Play
                                          </Index.TableCell>
                                        )}
                                        <Index.TableCell
                                          component="th"
                                          variant="th"
                                          className="table-th"
                                          align="right"
                                        >
                                          Action
                                        </Index.TableCell>
                                      </Index.TableRow>
                                    </Index.TableHead>
                                    <Index.TableBody className="table-body">
                                      {selectedData?.map((data, indexOuter) => {
                                        return (
                                          <Index.TableRow>
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              scope="row"
                                              className="table-td"
                                            >
                                              {data?.priority
                                                ? data?.priority[0]?.toUpperCase() +
                                                  data?.priority?.slice(
                                                    1,
                                                    data?.priority?.length
                                                  )
                                                : "-"}
                                            </Index.TableCell>
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              scope="row"
                                              className="table-td"
                                            >
                                              <Index.Typography className="add-schedule-tale-text">
                                                {
                                                  data?.creative?.clientId
                                                    ?.compName
                                                }
                                              </Index.Typography>
                                            </Index.TableCell>
                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Typography className="add-schedule-tale-text">
                                                {data?.creative?.name}
                                              </Index.Typography>
                                            </Index.TableCell>
                                            {page === "FCT" && (
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              >
                                                <Index.Typography className="add-schedule-tale-text">
                                                  {data?.creative?.duration}
                                                </Index.Typography>
                                              </Index.TableCell>
                                            )}
                                            {page === "NonFCT" && (
                                              <Index.TableCell
                                                component="td"
                                                variant="td"
                                                className="table-td"
                                              >
                                                <Index.Typography className="add-schedule-tale-text">
                                                  {data?.noOfTimesPlay}
                                                </Index.Typography>
                                              </Index.TableCell>
                                            )}

                                            <Index.TableCell
                                              component="td"
                                              variant="td"
                                              className="table-td"
                                            >
                                              <Index.Box className="admin-table-data-btn-flex">
                                                <Index.Tooltip
                                                  title="Delete"
                                                  arrow
                                                  placement="bottom"
                                                  className="admin-tooltip"
                                                >
                                                  <Index.Button
                                                    className="admin-table-data-btn"
                                                    onClick={() =>
                                                      handleRemoveSelectedData(
                                                        indexOuter,
                                                        data
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      src={PagesIndex.Svg.trash}
                                                      className="admin-icon"
                                                      alt="Delete"
                                                    ></img>
                                                  </Index.Button>
                                                </Index.Tooltip>
                                              </Index.Box>
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        );
                                      })}
                                    </Index.TableBody>
                                  </Index.Table>
                                </Index.TableContainer>
                              </Index.Box>
                            </Index.Box>
                          </>
                        ) : (
                          ""
                        )}
                      </Index.Box>
                      <Index.Box className="admin-filter-footer">
                        <Index.Box className="admin-filter-btn-main border-btn-main btn-main-primary">
                          <Index.Button
                            className="border-btn admin-filter-cancel-btn"
                            onClick={(e) => toggleDrawer("right", false)}
                            disabled={buttonSpinner}
                          >
                            Cancel
                          </Index.Button>
                          <Index.Button
                            className="btn-primary admin-filter-btn"
                            onClick={handleAddEditSchedule}
                            disabled={buttonSpinner}
                          >
                            {buttonSpinner ? <PagesIndex.Spinner /> : "Apply"}
                          </Index.Button>
                        </Index.Box>
                      </Index.Box>
                    </form>
                  );
                }}
              </PagesIndex.Formik>
            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Index.Box>
      <Index.Modal
        open={openChangeSlot}
        onClose={handleCloseChangeSlot}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <PagesIndex.Formik
          enableReinitialize
          onSubmit={handleChangeSlot}
          initialValues={initialValuesChangeSlot}
          validationSchema={PagesIndex.updateSlotTime}
        >
          {({ values, errors, touched, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit} noValidate="novalidate">
              <Index.Box
                sx={style}
                className="admin-add-user-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Edit Slot
                  </Index.Typography>
                </Index.Box>
                <Index.Box
                  className="admin-modal-hgt-scroll cus-scrollbar"
                  id="scrollDiv"
                >
                  <Index.Box className="grid-row">
                    <Index.Box sx={{ width: 1 }} className="grid-main">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        columnGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 12",
                            md: "span 12",
                            lg: "span 12",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box admin-modal-input-box">
                            <Index.FormHelperText className="admin-form-lable">
                              Slots<span className="astrick-sing">*</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <Index.Autocomplete
                                className="admin-auto-complete-control"
                                options={
                                  scheduleData
                                    ?.filter((data) => {
                                      const start = PagesIndex.moment(
                                        data?.tempData?.startTime
                                      ).format("HH:mm");
                                      const end = PagesIndex.moment(
                                        data?.tempData?.endTime
                                      ).format("HH:mm");
                                      const fromTime = PagesIndex.moment(
                                        movableSlotTime?.movebleStartTime
                                      ).format("HH:mm");
                                      const toTime = PagesIndex.moment(
                                        movableSlotTime?.movebleEndTime
                                      ).format("HH:mm");
                                      return (
                                        start >= fromTime &&
                                        end >= fromTime &&
                                        start <= toTime &&
                                        end <= toTime
                                      );
                                    })
                                    ?.map((data) => data?.tempData) || []
                                }
                                id="slotId"
                                closeText={""}
                                openText={""}
                                clearText={""}
                                disableClearable
                                value={
                                  values?.slotId
                                    ? scheduleData?.find(
                                        (o) =>
                                          o?.tempData?._id === values?.slotId
                                      )
                                    : values?.slotId || null
                                }
                                onChange={(e, value) => {
                                  setFieldValue("slotId", value?._id);
                                }}
                                getOptionLabel={(option) =>
                                  `${PagesIndex.moment(
                                    option?.tempData?.startTime
                                  ).format("HH:mm:ss")}-${PagesIndex.moment(
                                    option?.tempData?.endTime
                                  ).format("HH:mm:ss")}`
                                }
                                renderOption={(props, item) => (
                                  <li {...props} key={item?._id}>
                                    {PagesIndex.moment(item?.startTime).format(
                                      "HH:mm:ss"
                                    )}
                                    -
                                    {PagesIndex.moment(item?.endTime).format(
                                      "HH:mm:ss"
                                    )}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    className="admin-form-control"
                                    name="slotId"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                    placeholder="Select Slot"
                                  />
                                )}
                              />
                              {touched.slotId && errors.slotId && (
                                <PagesIndex.FormHelperText className="admin-error-text">
                                  {errors.slotId}
                                </PagesIndex.FormHelperText>
                              )}
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="modal-footer">
                  <Index.Box className="admin-modal-user-btn-flex">
                    <Index.Box className="admin-discard-btn-main border-btn-main">
                      <Index.Button
                        className="admin-discard-user-btn border-btn"
                        onClick={handleCloseChangeSlot}
                      >
                        Discard
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="admin-save-btn-main btn-main-primary">
                      <Index.Button
                        className="admin-save-user-btn btn-primary"
                        type="submit"
                      >
                        <img
                          src={PagesIndex.Svg.save}
                          className="admin-user-save-icon"
                          alt="Save"
                        />
                        <span>Update</span>
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </form>
          )}
        </PagesIndex.Formik>
      </Index.Modal>
      <Index.Modal
        open={openChangeSlotTiming}
        onClose={handleCloseChangeSlotTiming}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="admin-modal"
      >
        <PagesIndex.Formik
          enableReinitialize
          onSubmit={handleChangeSlotTimings}
          initialValues={initialValuesChangeSlotTimings}
          validationSchema={PagesIndex.updateSlotTimings}
        >
          {({ values, errors, touched, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit} noValidate="novalidate">
              <Index.Box
                sx={style}
                className="admin-add-user-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-header">
                  <Index.Typography
                    id="modal-modal-title"
                    className="admin-modal-title"
                    variant="h6"
                    component="h2"
                  >
                    Edit Slot Timing
                  </Index.Typography>
                </Index.Box>
                <Index.Box
                  className="admin-modal-hgt-scroll cus-scrollbar"
                  id="scrollDiv"
                >
                  <Index.Box className="grid-row">
                    <Index.Box sx={{ width: 1 }} className="grid-main">
                      <Index.Box
                        display="grid"
                        gridTemplateColumns="repeat(12, 1fr)"
                        columnGap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                      >
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 6",
                            lg: "span 6",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box admin-modal-input-box admin-date-input-main">
                            <Index.FormHelperText className="admin-form-lable">
                              <span>Start Time</span>
                              <span className="astrick-sing">*</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <PagesIndex.LocalizationProvider
                                dateAdapter={Index.AdapterDayjs}
                              >
                                <PagesIndex.TimePicker
                                  open={openStartTime}
                                  onClose={() => {
                                    setOpenStartTime(false);
                                  }}
                                  views={["hours", "minutes"]}
                                  timeSteps={{ minutes: 1, seconds: 1 }}
                                  className="admin-form-control admin-date-picker-control"
                                  ampm={false}
                                  maxTime={PagesIndex.dayjs(
                                    selectedSlotData?.startTime
                                  ).add(9, "minutes")}
                                  value={values.startTime} // Use '01/01/2000' as the default value
                                  onChange={(date) => {
                                    setFieldValue("startTime", date);
                                    setFieldValue("endTime", null);
                                  }}
                                  slotProps={{
                                    popper: {
                                      className: "date-picker-body",
                                    },
                                    textField: {
                                      readOnly: true,
                                      onClick: () => setOpenStartTime(true),
                                    },
                                    inputAdornment: {
                                      onClick: () => setOpenStartTime(true), // This triggers on the calendar icon
                                    },
                                  }}
                                />
                              </PagesIndex.LocalizationProvider>
                              <Index.FormHelperText className="admin-error-text">
                                {errors.startTime &&
                                  touched.startTime &&
                                  errors.startTime}
                              </Index.FormHelperText>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 6",
                            md: "span 6",
                            lg: "span 6",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box admin-modal-input-box admin-date-input-main">
                            <Index.FormHelperText className="admin-form-lable">
                              <span>End Time</span>
                              <span className="astrick-sing">*</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <PagesIndex.LocalizationProvider
                                dateAdapter={Index.AdapterDayjs}
                              >
                                <PagesIndex.TimePicker
                                  open={openEndTime}
                                  onClose={() => {
                                    setOpenEndTime(false);
                                  }}
                                  views={["hours", "minutes"]}
                                  timeSteps={{ minutes: 1, seconds: 1 }}
                                  className="admin-form-control admin-date-picker-control"
                                  ampm={false}
                                  minTime={PagesIndex.dayjs(
                                    values.startTime
                                  ).add(1, "minute")}
                                  maxTime={PagesIndex.dayjs(
                                    selectedSlotData?.startTime
                                  ).add(10, "minutes")}
                                  value={values.endTime} // Use '01/01/2000' as the default value
                                  onChange={(date) => {
                                    setFieldValue("endTime", date);
                                  }}
                                  slotProps={{
                                    popper: {
                                      className: "date-picker-body",
                                    },
                                    textField: {
                                      readOnly: true,
                                      onClick: () => setOpenEndTime(true),
                                    },
                                    inputAdornment: {
                                      onClick: () => setOpenEndTime(true), // This triggers on the calendar icon
                                    },
                                  }}
                                />
                              </PagesIndex.LocalizationProvider>
                              <Index.FormHelperText className="admin-error-text">
                                {errors.endTime &&
                                  touched.endTime &&
                                  errors.endTime}
                              </Index.FormHelperText>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="modal-footer">
                  <Index.Box className="admin-modal-user-btn-flex">
                    <Index.Box className="admin-discard-btn-main border-btn-main">
                      <Index.Button
                        className="admin-discard-user-btn border-btn"
                        onClick={handleCloseChangeSlotTiming}
                      >
                        Discard
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="admin-save-btn-main btn-main-primary">
                      <Index.Button
                        className="admin-save-user-btn btn-primary"
                        type="submit"
                      >
                        <img
                          src={PagesIndex.Svg.save}
                          className="admin-user-save-icon"
                          alt="Save"
                        />
                        <span>Update</span>
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </form>
          )}
        </PagesIndex.Formik>
      </Index.Modal>
    </Index.Box>
  );
};
export default React.memo(AddScheduleTable);
